export enum REQUIRED_LIGHTING {
  NONE = "none",
  ADAPTIVE = "adaptive",
  DEFAULT = "default",
}
